import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { PrinterIcon, GraduationCapIcon, ZapIcon, ArrowRightIcon } from 'lucide-react';
import { BookMockup } from './BookMockup';
const trust = [{
  icon: ZapIcon,
  label: 'Instant Digital Access'
}, {
  icon: PrinterIcon,
  label: 'Print at Home or School'
}, {
  icon: GraduationCapIcon,
  label: 'Grades 1–5'
}];
export function Hero() {
  const reduce = useReducedMotion();
  const rise = (delay: number) => ({
    initial: reduce ? {} : {
      opacity: 0,
      y: 14
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.28,
      delay,
      ease: [0.23, 1, 0.32, 1] as const
    }
  });
  return <section className="cube-grid relative overflow-hidden bg-navy-900" data-id="element-92" data-mp="s9gji7eh2ubv">
      <div aria-hidden="true" className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-brand-emerald/40 to-transparent" data-id="element-93" data-mp="nbez9j5b8oyt" />
      <div className="mx-auto grid w-full max-w-6xl gap-10 px-4 pb-14 pt-10 sm:px-6 sm:pb-20 sm:pt-14 lg:grid-cols-[1.05fr_0.95fr] lg:items-center lg:gap-14 lg:pb-24 lg:pt-20" data-id="element-94" data-mp="381xmf1kmf8br">
        <div className="text-center lg:text-left" data-id="element-95" data-mp="3o7lshs6gf8ph">
          <motion.p {...rise(0)} className="inline-flex items-center gap-2 border-2 border-brand-emerald/60 bg-brand-emerald/10 px-3 py-1.5 font-pixel text-[9px] uppercase leading-none tracking-[0.14em] text-brand-emerald sm:text-[11px]" data-id="element-96" data-mp="3o6aq9wsnq90h">
            <span className="h-2 w-2 bg-brand-emerald" aria-hidden="true" data-id="element-97" data-mp="30hhsrvwdzt3r" />
            Grades 1–5 • 200+ Exercises • Print &amp; Play
          </motion.p>

          <motion.h1 {...rise(0.05)} className="mt-5 text-[34px] font-extrabold leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-[56px]" data-id="element-98" data-mp="35audvw1uxhrr">
            Make Math Practice{' '}
            <span className="text-brand-emerald" data-id="element-99" data-mp="2hj5ig6tqod6l">Click</span> — One Challenge at
            a Time.
          </motion.h1>

          <motion.p {...rise(0.1)} className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-slate-300 sm:text-lg lg:mx-0" data-id="element-100" data-mp="2ll0dwuoznwcg">
            A ready-to-use collection of visual math challenges for school and
            home.
          </motion.p>

          <motion.div {...rise(0.15)} className="mt-7 lg:hidden" data-id="element-101" data-mp="ibypabmmn01n">
            <BookMockup data-id="element-102" data-mp="ia5jsznr2lv8" />
          </motion.div>

          <motion.div {...rise(0.2)} className="mt-8" data-id="element-103" data-mp="ddwxn2b4xsek">
            <a href="#offer" className="group inline-flex w-full items-center justify-center gap-2 border-b-4 border-[#b47a08] bg-brand-gold px-6 py-4 font-pixel text-[11px] uppercase tracking-[0.12em] text-navy-900 transition-[transform,background-color] duration-150 ease-out hover:bg-[#ffc23f] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand-cyan active:translate-y-[2px] sm:w-auto sm:text-sm" data-id="element-104" data-mp="dbaowzcid6ur">
              Get the Complete Edition
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-105" data-mp="3hqtz20f4xpwf" />
            </a>
          </motion.div>

          <motion.ul {...rise(0.25)} className="mt-7 flex flex-col items-center gap-3 text-sm text-slate-300 sm:flex-row sm:flex-wrap sm:justify-center lg:justify-start" data-id="element-106" data-mp="21bpo3l0bc13u">
            {trust.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-2 whitespace-nowrap" data-id="element-107" data-mp="2g02iwennzdwr">
                <Icon className="h-4 w-4 shrink-0 text-brand-cyan" aria-hidden="true" data-id="element-108" data-mp="2kyvo7jssrylu" />
                <span data-id="element-109" data-mp="2l0q9iz7zdsqg">{label}</span>
              </li>)}
          </motion.ul>
        </div>

        <motion.div initial={reduce ? {} : {
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="hidden lg:block" data-id="element-110" data-mp="2oyo28c0ymwyl">
          <BookMockup data-id="element-111" data-mp="zmc2c8fcyx68" />
        </motion.div>
      </div>
    </section>;
}